import React, {useCallback, useState} from 'react';
import axios from 'axios';
import cn from "classnames";
// import {createUser, login, resetPassword} from '../../api/user';
import {privacy, service} from './data';
import Button from '../button/button.jsx';
import Modal from '../modal/modal.jsx';
import PhoneInput from '../forms/phone-input/phone-input.jsx';
import UserNameInput from '../user-name-input/user-name-input.jsx';
import VerifyCodeInput from '../forms/verify-code-input/verify-code-input.jsx';
import FullScreen from './FullScreen.jsx';
import ModalClass from '../modal/modal-manager.jsx';
import message from '../../components/message/message.jsx';
import s from './index.scss';
import PasswordInput from "../forms/password-input/pasword-input";
import ErrorMsg from "../error-msg/error-msg";
// import {getCourseRecords} from "../../api/course-record";
// import {getMyProjects} from "../../api/project";
import {hideLoading} from "../loading/loading";
import ConfirmPhoneModal from './confirm-phone';
import ModalManager from '../modal/modal-manager'

const LoginRegModal = ({onClose, onSubmit, setUser, showLoading}) => {
    const PAGE_LOGIN = 0;
    const PAGE_REGISTER = 1;
    const PAGE_RESET_PASSWORD = 2;
    const titles = [window.L("teach.user.login"), window.L("teach.user.register"), window.L("teach.user.resetPassword")];
    const [page, setPage] = useState(PAGE_LOGIN);
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConform] = useState('');
    const [inputCode, setInputCode] = useState('');
    const [inputCodeErr, setInputCodeErr] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [name, setName] = useState('');
    const onFinalSubmit = useCallback(() => {
        onSubmit();
    }, [onSubmit]);

    const handleLoginSuccess = (user) => {
        // setUser(user);
        axios.defaults.headers['api-token'] = localStorage.getItem('api-token');
        window.store.dispatch(setUser(user));
        hideLoading();
        // window.location.reload();
        localStorage.removeItem('HYEBRKLD');
        message.show(window.L('teach.user.successLogin'));
    }

    const loginPost = (phone,pwd) => {
        let request = {
            password: pwd,
            phone: phone,
        };
        try {
            showLoading(window.L('teach.user.logining'));
            // let user = await login(request);
            axios.post(`${window.config.apiBaseURL}${url}`, request).then(res => {
                let user = res.data.data
                localStorage.setItem('api-token', user.api_token)
                handleLoginSuccess(user);
                onFinalSubmit();
            })
            .catch((err) => {
                hideLoading();
                if (err.response) {
                    setErrorMsg(err.response.data.msg);
                } else {
                    setErrorMsg('账号或密码错误');
                }
            })
        } catch (error) {
            // eslint-disable-next-line no-alert
            hideLoading();
            if (error.msg || error.data) {
                setErrorMsg(error.msg || error.data);
            } else {
                setErrorMsg(error.toString());
            }
        }
    }

    const url = location.origin.includes('localhost') || location.port == "8877" || location.origin.includes('dev.zhiaotech.com') || location.origin.indexOf("192.168.") >= 0 || location.origin.indexOf("127.0.0.1") >= 0 ? '/user/login' : '/user/login';

    return (
        <Modal
            onClose={onClose}
            tips={page === PAGE_LOGIN ? '通过手机号登录' : ''}
            title={titles[page]}
        >
            <ErrorMsg errorMsg={errorMsg} click={()=>{setPage(PAGE_RESET_PASSWORD);setErrorMsg(null);}} />
            {
                page === PAGE_LOGIN &&
                (
                    <React.Fragment>
                        <PhoneInput
                            placeholder="请输入手机号"
                            defaultValue={mobile}
                            onChange={v => {
                                setMobile(v);
                            }}
                        />
                        <PasswordInput
                            onChange={v => {
                                setPassword(v);
                            }}
                        />
                        <div style={{color: "#5391E4", fontSize: "14px", marginTop: "-15px", marginBottom: '15px', textAlign: 'center'}}>
                            <span
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                    setPage(PAGE_RESET_PASSWORD)
                                }}
                            >
                                忘记密码？重置密码！
                            </span>
                        </div>
                        <div className={s.text}>
                            {'登录即表示同意'}
                            <span
                                style={{color: 'red', cursor: 'pointer'}}
                                onClick={() => {
                                    ModalClass.open(FullScreen, {
                                        title: '用户服务协议',
                                        content: service,
                                        onClose: ModalClass.pop
                                    });
                                }}
                            >
                                {'《服务协议》'}
                            </span>
                            {'和'}
                            <span
                                style={{color: 'red', cursor: 'pointer'}}
                                onClick={() => {
                                    ModalClass.open(FullScreen, {
                                        title: '隐私政策',
                                        content: privacy,
                                        onClose: ModalClass.pop
                                    });
                                }}
                            >
                                {'《隐私政策》'}
                            </span>
                            <br />

                        </div>

                        <div style={{textAlign: 'center'}}>
                            <Button
                                id="login"
                                theme="submit"
                                label="登录"
                                onClick={() => {
                                    if (mobile && password) {
                                        loginPost(mobile,password)
                                    }
                                }}
                            />
                            <Button
                                style={{marginLeft: "30px"}}
                                label="注册"
                                onClick={() => {
                                    if (/^\d+$/.test(name)) { //手机号登录
                                        setMobile(name);
                                        setName('');
                                    }
                                    setPage(PAGE_REGISTER);
                                }}
                            />
                        </div>
                    </React.Fragment>
                )
            }
            {
                page === PAGE_REGISTER &&
                (
                    <React.Fragment>
                        <UserNameInput
                            defaultValue={name}
                            onChange={v => {
                                setName(v);
                            }}
                        />
                        <PasswordInput
                            onChange={v => {
                                setPassword(v);
                            }}
                        />
                        <PasswordInput
                            placeholder="请再输入一次密码"
                            onChange={v => {
                                setPasswordConform(v);

                            }}
                            verify={v => {
                                if (!v.length) {
                                    throw new Error('请重复输入密码');
                                } else if (v != password) {
                                    throw new Error('两次输入密码不一致');
                                }
                                return true;
                            }}
                        />
                        <PhoneInput
                            defaultValue={mobile}
                            onChange={v => {
                                setMobile(v);
                            }}
                        />
                        {/* <VerifyCodeInput
                            mobile={mobile}
                            err={inputCodeErr}
                            onChange={v => {
                                setInputCodeErr('');
                                setInputCode(v);
                            }}
                        /> */}
                        <div style={{textAlign: 'center'}}>
                            <Button
                                label="提交"
                                onClick={
                                    async () => {
                                        if (mobile && name && password && passwordConfirm) {
                                            ModalManager.open(ConfirmPhoneModal, {
                                                phone: mobile,
                                                onClose: () => {},
                                                onApply: async (v) => {
                                                    if (v) {
                                                        ModalManager.pop();
                                                        try {
                                                            showLoading(window.L('teach.user.registering'));
                                                            const params = {
                                                                phone: mobile,
                                                                // code: inputCode,
                                                                name,
                                                                password,
                                                                password_confirmation: passwordConfirm,
                                                            }
                                                            await axios.post(`${window.config.apiBaseURL}/user/create`, params).then(response => {
                                                                loginPost(mobile,password)
                                                            }).catch((err) => {
                                                                if (err.response) {
                                                                    return Promise.reject(err.response.data)
                                                                }
                                                            });
                                                        } catch (error) {
                                                            // eslint-disable-next-line no-alert
                                                            hideLoading();
                                                            if (error.msg || error.data) {
                                                                setErrorMsg(error.msg || error.data);
                                                            } else {
                                                                setErrorMsg(error.toString());
                                                            }
                                                        }

                                                    }
                                                }
                                            })
                                        }
                                    }
                                }
                            />
                        </div>
                    </React.Fragment>
                )
            }
            {page == PAGE_RESET_PASSWORD &&
                (
                    <React.Fragment>
                        <PhoneInput
                            defaultValue={mobile}
                            onChange={v => {
                                setMobile(v);
                            }}
                        />
                        <VerifyCodeInput
                            mobile={mobile}
                            err={inputCodeErr}
                            onChange={v => {
                                setInputCodeErr('');
                                setInputCode(v);
                            }}
                        />
                        <PasswordInput
                            placeholder="请输入新密码"
                            onChange={v => {
                                setPassword(v);
                            }}
                        />
                        <PasswordInput
                            placeholder="请再输入一次新密码"
                            onChange={v => {
                                setPasswordConform(v);

                            }}
                            verify={v => {
                                if (!v.length) {
                                    throw new Error('请重复输入密码');
                                } else if (v != password) {
                                    throw new Error('两次输入密码不一致');
                                }
                                return true;
                            }}
                        />
                        <div style={{textAlign: 'center'}}>
                            <Button
                                label="提交"
                                onClick={async () => {
                                    if (mobile && inputCode && password && passwordConfirm) {
                                        try {
                                            const params = {
                                                phone: mobile,
                                                code: inputCode,
                                                password,
                                                password_confirmation: passwordConfirm,
                                            }
                                            await axios.post(`${window.config.apiBaseURL}/user/reset-password`, params).then(response => {
                                                let user = response.data.data
                                                if(user === '该手机号码尚未注册'){
                                                    setErrorMsg(user);
                                                    return
                                                }else{
                                                    loginPost(mobile,password)
                                                }
                                            }).catch((err) => {
                                                if (err.response) {
                                                    return Promise.reject(err.response.data)
                                                }
                                            });
                                        } catch (error) {
                                            // eslint-disable-next-line no-alert
                                            hideLoading();
                                            if (error.msg || error.data) {
                                                setErrorMsg(error.msg || error.data);
                                            } else {
                                                setErrorMsg(error.toString());
                                            }

                                        }
                                    }
                                }}
                            />
                        </div>
                    </React.Fragment>
                )
            }
        </Modal>
    );
};

export default LoginRegModal;
